import React, {useCallback, useEffect, useMemo, useState} from "react";
import Slider from "react-slick";
import {useDispatch, useSelector} from "react-redux";
import {IAppState} from "../../../store/models";
import Flyer2Pages from "./Flyer2Pages/Flyer2Pages";
// import {zoomIn} from "../../../store/actionsCreator/zoomActionCreators";
import {Box} from "@mui/material";
import {isMobile} from 'react-device-detect';
import {useParams} from "react-router-dom";
import {IFlyerRuntimePage, ParamTypesDto} from "../../../dtos/flyer";
import Flyer from "../SliderFor1Flyer/Flyer";
import {
    calculateCorrectPageFromShareLink,
    getConvertedPageNumberToSlideNumber
} from "../../../com/globalsFunctions/globalFunctions";
import {scrollInZoomInMode} from "../../../store/actionsCreator/zoomActionCreators";

// import useSound from "use-sound";
// import pageFlipSound from "../../../assets/audio/page-flip-sound.wav";

// const Flyer = lazy(() => import("../SliderFor1Flyer/Flyer"))


const RenderContent = (flyers: any, calculateFlyerContainerHeightWidth: any, sliderRef?: any) => {
    const {
        controlsBranch,
        selectedSpot,
        easterEggDataFromStore,
        flyersBranch
    } = useSelector((state: IAppState) => state);
    const [pages, setPages] = useState<IFlyerRuntimePage[]>([]);
    const {showBasket, isFullScreen, isHelpScreen, showSearch, isTocOpen, shareMenu} = controlsBranch;
    const isHebrewStyle = flyers?.dir === "RTL";
    // const isVerticalScrolling = true;
    // const isOnePageOrientation: boolean = false;
    const isVerticalScrolling = flyersBranch.data?.pageLayoutPc === 2 || flyersBranch.data?.pageLayoutPc === 3;
    const isOnePageOrientation: boolean = flyersBranch.data?.pageLayoutPc === 3 || flyersBranch.data?.pageLayoutPc === 4;
    // const isMobile = useMediaQuery("(max-width:767px)", {noSsr: true});

    useEffect(() => {
        setPages(flyersBranch.data?.pages || []);
    }, [flyersBranch.data?.pages.length]);

    const onBackgroundClick = (event: React.MouseEvent<HTMLDivElement>) => {
        if (event.altKey && (event.ctrlKey || event.metaKey) && event.button === 0 && event.target === event.currentTarget) {
            event.preventDefault();
            alert(easterEggDataFromStore.flyerRenderTimeWithLabelInString);
        }
    }


    return pages.map((key: IFlyerRuntimePage, index: number) => {
        let isEvenNumberOfPages = pages.length % 2 === 0;
        let isOnePage: boolean = index === 0 || (index === pages.length - 1 && pages.length % 2 === 0) || isOnePageOrientation ;
        let isTwoPage = index % 2 !== 0 && !isOnePageOrientation;
        if (isHebrewStyle && !isEvenNumberOfPages && !isOnePageOrientation && !isVerticalScrolling) {
            isOnePage = index === pages.length - 1;
            isTwoPage = index % 2 === 0;
        }
        if(!isOnePageOrientation && pages.length === 2){
            isOnePage = false;
            isTwoPage = index === 0;
        }
        if (isOnePage) {
            const {height, width: page1Width} = calculateFlyerContainerHeightWidth(key);
            return (
                <Box key={key.pageId} sx={{
                    width: isVerticalScrolling ? "100%" : "100vw!important",
                }}>
                    <Box
                        style={{
                            userSelect: `none`,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            minHeight: isVerticalScrolling ? height : `calc(${document.documentElement.clientHeight}px - 60px)`,
                            // height: isVerticalScrolling ? height : `calc(${document.documentElement.clientHeight}px - 60px)`,
                            margin: `${(showBasket || isHelpScreen || shareMenu.isOpen || showSearch || isTocOpen || (Boolean(selectedSpot.spot) && !selectedSpot.isExpanded)) && !isVerticalScrolling ? (isHebrewStyle ? '0 0 0 430px' : '0 430px 0 0') : "0"}`
                        }}
                        onClick={onBackgroundClick}
                    >
                        <Box
                            style={{
                                height: height,
                                // height: isVerticalScrolling && isOnePageOrientation && Boolean(key.displayImageUrl) ? height : height,
                                width: page1Width,
                                position: 'relative',
                                padding: isVerticalScrolling ? `5px` : `0`
                            }}
                        >
                            <Flyer page={key}
                                   handleInternalZooming={!isMobile && !isFullScreen} sliderRef={sliderRef}
                                   isOnePage={true}/>
                        </Box>
                    </Box>

                </Box>
            )
        } else if (isTwoPage) {
            const {height: page1Height, width: page1Width} = calculateFlyerContainerHeightWidth(key);
            const {height: page2Height, width: page2Width} = calculateFlyerContainerHeightWidth(pages[index + 1]);

            return (
                <Box key={key.pageNumber}>
                    <Box
                        sx={{
                            margin: `${(showBasket || isHelpScreen || shareMenu.isOpen || showSearch || isTocOpen || (Boolean(selectedSpot.spot) && !selectedSpot.isExpanded)) && !isVerticalScrolling ? (isHebrewStyle ? '0 0 0 430px' : '0 430px 0 0') : "0"}`,
                            // height: `calc(${document.documentElement.clientHeight}px - 60px)`,
                            minHeight: isVerticalScrolling ? page1Height : `calc(${document.documentElement.clientHeight}px - 60px)`,
                            // height: isVerticalScrolling ? page1Height : `calc(${document.documentElement.clientHeight}px - 60px)`,
                            //padding: 50px;
                            overflow: `hidden`,
                            display: `flex`,
                            justifyContent: `center`,
                            alignItems: `center`,
                            padding: isVerticalScrolling ? `5px 0` : `0`,
                            userSelect: `none`,
                        }}
                        onClick={onBackgroundClick}
                    >
                        <Box
                            id={"twoSlidesWrapper"}
                            sx={{
                                position: `relative`,
                                height: page1Height,
                                // overflow: `hidden`
                            }}
                        >
                            <Box
                                sx={{
                                    height: page1Height,
                                    width: page1Width + page2Width,
                                    position: 'relative',
                                }}
                            >
                                <Flyer2Pages
                                    sliderRef={sliderRef}

                                    page1Width={isHebrewStyle ? page2Width : page1Width}
                                    page2Width={isHebrewStyle ? page1Width : page2Width}
                                    page1Height={page1Height}
                                    page2Height={page2Height}

                                    page1={isHebrewStyle ? pages[index + 1] : key}
                                    page2={isHebrewStyle ? key : pages[index + 1]}
                                    isHebrewStyle={isHebrewStyle}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            )
        }
    })

}

type Props = {
    handleSwipe: any;
    settings: object;
    calculateFlyerContainerHeightWidth: any;
    sliderRef: any;
    setPageRangeInUrl: (pageNumber: number) => void;
}

const SliderFor2Flyer: React.FC<Props> = ({
                                              handleSwipe,
                                              settings,
                                              calculateFlyerContainerHeightWidth,
                                              sliderRef,
                                              setPageRangeInUrl
                                          }) => {
    const dispatch = useDispatch();
    const {flyersBranch, zoomBranch} = useSelector((state: IAppState) => state);
    const {data: flyers} = flyersBranch;
    const isVerticalScrolling = flyersBranch.data?.pageLayoutPc === 2 || flyersBranch.data?.pageLayoutPc === 3;
    const isOnePageOrientation: boolean = flyersBranch.data?.pageLayoutPc === 3 || flyersBranch.data?.pageLayoutPc === 4;
    const isHebrewStyle = flyers?.dir === "RTL";
    // const [pageFlip, exposedData] = useSound(pageFlipSound);


    const {pageNumber} = useParams<ParamTypesDto>();
    //get lowest number in URL pages range
    const pageStringToNumberIndex = useMemo(() => calculateCorrectPageFromShareLink(pageNumber), [pageNumber]);
    //convert page number to slide number
    const currentSlideNumber = useMemo(() => getConvertedPageNumberToSlideNumber(pageStringToNumberIndex, isMobile || isOnePageOrientation, isHebrewStyle, flyers?.pages), [pageStringToNumberIndex, isMobile, isHebrewStyle, flyers?.pages, isOnePageOrientation]);

    useEffect(() => {
        return () => {
            if (document.getElementsByClassName('for_page_flyer')) {
                document.getElementsByClassName('for_page_flyer')[0]?.setAttribute("style", `display: none`);
                const iDiv = document.createElement('div');
                iDiv.id = 'loaderWrapper';
                iDiv.className = 'loaderWrapper';
                document.getElementsByClassName('for_page_flyer')[0]?.parentElement?.appendChild(iDiv);
            }
        }
    }, []);

    let scrollCount: any = null;
    let scrollRef: any = null;
    const decreaseValue = isOnePageOrientation ? 1 : 2;
    const maxSlideNumber = Math.floor(flyers!.pages.length / decreaseValue);
    const scroll = useCallback(
        (y) => {
            if (sliderRef && sliderRef.current && zoomBranch.scale === 0) {
                if (y > 0) {
                    if (!isHebrewStyle) {
                        if (currentSlideNumber < maxSlideNumber) {
                            (sliderRef.current as any).slickGoTo(currentSlideNumber + 1, true);
                        }
                    } else {
                        if (currentSlideNumber > 0) {
                            (sliderRef.current as any).slickGoTo(currentSlideNumber - 1, true);
                        }
                    }
                } else {
                    if (!isHebrewStyle) {
                        if (currentSlideNumber > 0) {
                            (sliderRef.current as any).slickGoTo(currentSlideNumber - 1, true);
                        }
                    } else {
                        if (currentSlideNumber < maxSlideNumber) {
                            (sliderRef.current as any).slickGoTo(currentSlideNumber + 1, true);
                        }
                    }
                }
            } else if (zoomBranch.scale === 1){
                const stepForScroll = 0.1;
                if (y > 0) {
                    dispatch(scrollInZoomInMode({...zoomBranch, pivotY: zoomBranch.pivotY + stepForScroll > 1 ? 1 : zoomBranch.pivotY + stepForScroll}));
                } else {
                    dispatch(scrollInZoomInMode({...zoomBranch, pivotY: zoomBranch.pivotY - stepForScroll < 0 ? 0 : zoomBranch.pivotY - stepForScroll}));
                }
            }
        },
        [sliderRef, currentSlideNumber, zoomBranch]
    );

    useEffect(() => {
        const sliderElement = document.querySelector('.for_page_flyer') as HTMLElement;
        let listenerExists = false;

        if (sliderElement) {
            if (sliderElement.onwheel !== null) {
                listenerExists = true;
            } else {
                sliderElement.addEventListener('wheel', onScrollPages);
            }
        }

        return () => {
            if (sliderElement && !listenerExists) {
                sliderElement.removeEventListener('wheel', onScrollPages);
            }
        };
    }, [scroll]);

    const onScrollPages = (e: any) => {
        // e.preventDefault();
        clearTimeout(scrollRef);
        scrollRef = setTimeout(() => {
                scrollCount = 0;
            },
            100);
        if (scrollCount) {
            return;
        }
        scrollCount = 1;

        scroll(e.deltaY);
    }



    return (
        <>
            {
                isVerticalScrolling
                    ?
                    <>
                        {RenderContent(flyers, calculateFlyerContainerHeightWidth)}
                    </>
                    :
                    <Slider
                        onSwipe={handleSwipe}
                        ref={sliderRef}
                        className={`for_page_flyer`}
                        beforeChange={(currentSlideNumber, nextSlide) => {
                            setPageRangeInUrl(nextSlide);
                        }}
                        {...settings}
                        // accessibility={false} // disable keyboard events
                    >
                        {RenderContent(flyers, calculateFlyerContainerHeightWidth, sliderRef)}
                    </Slider>
            }
        </>
    )
}

export default SliderFor2Flyer;